$recipe-routes-border-color:'#596E7E' !default;
$recipe-routes-background:'#182535' !default;
$recipe-routes-shadow:'-4px 0 2px -1px black' !default;
$recipe-routes-container-background1:'#17232E' !default;
$recipe-routes-container-background2:'#2A475A' !default;
$recipe-routes-container-background:'#17232E' !default;
$recipe-routes-color:'white' !default;



@mixin container {
  border-bottom: 1px solid #{$recipe-routes-border-color};
  border-top: 1px solid #{$recipe-routes-border-color};
  background:#{$recipe-routes-container-background};
}

@mixin container-editor {
  border-bottom: 1px solid #{$recipe-routes-border-color};
  border-top: 2px solid #{$recipe-routes-border-color};
  background: linear-gradient(20deg, #{$recipe-routes-container-background1} 20%, #{$recipe-routes-container-background2} 20%);
}

@mixin content {
  background: #{$recipe-routes-background};
  border: 2px solid #{$recipe-routes-border-color};
  border-bottom:1px solid #{$recipe-routes-border-color};
  box-shadow: #{$recipe-routes-shadow};
}

@mixin containers($contentName,$contentBorderTop){
  .container-fluid-#{$contentName}{
    @if($contentName == editor){
      @include container-editor;
    }
    @else{
      @include container;
    }
    .#{$contentName} {
      @include content;
      border-top:$contentBorderTop;
    }
  }
}

.nav-routes {
  color: #{$recipe-routes-color};
  @include containers(editor,0);
  @include containers(category,1px solid #{$recipe-routes-border-color});
  @include containers(flags,1px solid #{$recipe-routes-border-color});
  @include containers(settings,1px solid #{$recipe-routes-border-color});
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/recipe/recipe-routes/recipe-routes-theme.scss